import { render, staticRenderFns } from "./PwaPrompt.vue?vue&type=template&id=36496091&"
import script from "./PwaPrompt.vue?vue&type=script&lang=js&"
export * from "./PwaPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports